import React, { useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { onPressEnterModal } from '@app/helpers';
import { PasslyButton } from '@app/components';
import { CircularProgress } from '@material-ui/core';

interface IReceivedData {
    luckyYouCallback: Function
}

const OnboardLuckyYouComponent = (props: IReceivedData) => {
    const { translation } = useTypedTranslation();

    const [isLoad, setIsLoad] = useState(false);

    const moveOnClicked = () => {
        setIsLoad(true);
        props.luckyYouCallback();
    };

    return (
        <>
            <div className='login' tabIndex={0} onKeyPress={onPressEnterModal(moveOnClicked)}>
                <div className='onboard'>
                    <div className='onboard__onboard-content'>
                        <div className='onboard__message' style={{ zIndex: 1 }}>
                            <div className='onboard__line1'>{translation('ONBOARD_LUCKYYOU_LINE1')}</div>
                            <div className='onboard__line2'>{translation('ONBOARD_LUCKYYOU_LINE2')}</div>
                            <div className='onboard__line3'>{translation('ONBOARD_LUCKYYOU_LINE3')}</div>
                            <div className='onboard__line4'>{translation('ONBOARD_LUCKYYOU_LINE4')}</div>
                            <PasslyButton variant='contained' color='primary' id='moveOnClicked'
                                onClick={() => moveOnClicked()}>
                                {translation('ONBOARD_LUCKYYOU_LETS_MOVE_ON')}
                                {isLoad && <CircularProgress size={24} className='button--loading__bar' />}
                            </PasslyButton>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OnboardLuckyYouComponent;